import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookingsRoutingModule } from './bookings-routing.module';

@NgModule({
  imports: [
    CommonModule,
    BookingsRoutingModule
  ]
})
export class BookingsModule { }
